"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PersonalDetails = void 0;
Object.defineProperty(exports, "findPersonById", {
  enumerable: true,
  get: function get() {
    return _personalDetailsUtils.findPersonById;
  }
});
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.string.trim.js");
require("core-js/modules/esnext.iterator.constructor.js");
require("core-js/modules/esnext.iterator.map.js");
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _personalDetailsUtils = require("./personalDetailsUtils.js");
var _reactRouterDom = require("react-router-dom");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const PersonalDetails = props => {
  const {
    page,
    scheduleData,
    person,
    imageUrl,
    t
  } = props;
  const navigate = (0, _reactRouterDom.useNavigate)();
  const goBack = () => {
    navigate(-1);
  };
  const speakerEvent = (0, _personalDetailsUtils.getSpeakerEventData)(page, scheduleData, person.speakerId);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "con-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "con-content con-text"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "speaker-info-header display-small-screen"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "con-heading con-heading__h3"
  }, person.name), /*#__PURE__*/_react.default.createElement("p", {
    className: "con-subtitle con-heading con-heading__h5 con-heading__h5--fw400"
  }, person.speechTitle)), /*#__PURE__*/_react.default.createElement("div", {
    className: "con-title-container con-speakers__speaker"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "speaker-section-content"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "con-image__container",
    style: {
      backgroundImage: "url(".concat(imageUrl, ")")
    }
  }), /*#__PURE__*/_react.default.createElement("p", {
    className: "con-subtitle con-text con-text__Xtra-larger-SemiBold con-centered"
  }, person.jobTitle.split(",").map((item, index, array) => /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
    key: index
  }, item.trim(), index < array.length - 1 && ",", index < array.length - 1 && /*#__PURE__*/_react.default.createElement("br", null)))), /*#__PURE__*/_react.default.createElement("p", {
    className: "con-subtitle con-text con-text__Xtra-larger-SemiBold con-text__Xtra-larger-SemiBold--dark-green con-text__Xtra-larger-SemiBold--bold con-centered "
  }, person.company)), /*#__PURE__*/_react.default.createElement("div", {
    className: "speaker-section-content"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "speaker-info-header display-big-screen"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "con-heading con-heading__h3"
  }, person.name)), Array.isArray(speakerEvent) && speakerEvent.length > 0 ? speakerEvent.map((event, index) => /*#__PURE__*/_react.default.createElement("div", {
    key: index
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "con-subtitle con-heading con-heading__h5 con-heading__h5--fw400"
  }, event.title), event.abstract.split("\n").map((line, index) => /*#__PURE__*/_react.default.createElement("p", {
    key: index,
    className: "con-subtitle con-text con-text__Xtra-larger-regular--no-scale"
  }, line, /*#__PURE__*/_react.default.createElement("br", null))))) : /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("p", {
    className: "con-subtitle con-heading con-heading__h5 con-heading__h5--fw400"
  })), speakerEvent !== null && /*#__PURE__*/_react.default.createElement("p", {
    className: "con-subtitle__more-space con-text con-text__Xtra-larger-regular--no-scale con-text__Xtra-larger-regular--bold"
  }, "About ", person.name.split(" ")[0]), person.description.split("\n").map((line, index) => /*#__PURE__*/_react.default.createElement("p", {
    key: index,
    className: "con-text con-text__Xtra-larger-regular--no-scale"
  }, line, /*#__PURE__*/_react.default.createElement("br", null))), /*#__PURE__*/_react.default.createElement("button", {
    className: "margin-top-25 speaker-back-button con-text con-text__Xtra-larger-regular--no-scale  con-text__Xtra-larger-regular--underline link-styles__1",
    onClick: () => goBack()
  }, t("Common.Back"))))));
};
exports.PersonalDetails = PersonalDetails;
PersonalDetails.propTypes = {
  page: _propTypes.default.string,
  scheduleData: _propTypes.default.object,
  person: _propTypes.default.object,
  t: _propTypes.default.func
};